import { BILLING_READ, BILLING_WRITE, LEVELING_READ_KEYS } from "./access.ts";
import { BACKFILL_GRANT, LEVELING_GRANT } from "./entitlement.ts";

export const BILLING_KEYS: readonly string[] = [BILLING_READ, BILLING_WRITE];

export const FIRST_READ_PATHS = {
  backfill: "/t/{tenantId}/api/backfill",
  roles: "/t/{tenantId}/api/analytics/entities/roles",
  channels: "/t/{tenantId}/api/analytics/entities/channels",
  settings: "/t/{tenantId}/api/settings",
  bounds: "/t/{tenantId}/api/analytics/coverage/bounds",
  disclosure: "/t/{tenantId}/api/analytics/disclosure",
  leveling: "/t/{tenantId}/api/leveling/config",
  plan: "/api/tenants/{tenantId}/billing/plan",
} as const;

export const OFFERS_PATH = "/api/billing/offers";

export type FirstRead = keyof typeof FIRST_READ_PATHS;

export const FIRST_READS = Object.keys(FIRST_READ_PATHS) as readonly FirstRead[];

export interface ReadBasis {
  readonly guildId: string;
  readonly grants: readonly string[];
  readonly permissions: readonly string[];
}

const holdsAny = (permissions: readonly string[], keys: readonly string[]): boolean =>
  keys.some((key) => permissions.includes(key));

export const firstReadsOf = (basis: ReadBasis): Readonly<Record<FirstRead, boolean>> => ({
  backfill: basis.grants.includes(BACKFILL_GRANT),
  roles: true,
  channels: true,
  settings: true,
  bounds: true,
  disclosure: true,
  leveling:
    basis.grants.includes(LEVELING_GRANT) && holdsAny(basis.permissions, LEVELING_READ_KEYS),
  plan: holdsAny(basis.permissions, BILLING_KEYS),
});

const byGuild = (path: string): boolean => path.startsWith("/t/");

export const firstReadUrl = (read: FirstRead, tenantId: string, guildId: string): string => {
  const path = FIRST_READ_PATHS[read].replace("{tenantId}", encodeURIComponent(tenantId));
  return byGuild(path) ? `${path}?${new URLSearchParams({ guildId })}` : path;
};
